import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * PortfolioSidebar
 * Lista lateral de Colaboradores no layout Master-Detail.
 * Ao selecionar um employee, o painel detail exibe os clientes dele.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const PortfolioSidebar = ({
    employees = [],
    activeId,
    onSelect,
    loading
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar colaboradores baseado na pesquisa local
    const filteredEmployees = employees.filter((employee) => {
        const name = employee.fullName || `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.email || "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Mapear colaboradores para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredEmployees.map((employee) => {
        const label = employee.fullName || `${employee.firstName || ""} ${employee.lastName || ""}`.trim() || employee.email || "Colaborador";
        return {
            id: employee.id,
            label: label,
            description: employee.roleName || employee.role || "Colaborador",
            photoUrl: employee.photoUrl || null,
            icon: "mdi-account-outline",
            badge: employee.status === GLOBAL_STATUS.INACTIVE ? "Inativo" : null,
            badgeVariant: employee.status === GLOBAL_STATUS.INACTIVE ? "muted" : null
        };
    });

    return (
        <NeoSideMenu
            title="Colaboradores"
            subtitle={`${employees.length} colaboradores`}
            icon="mdi-account-group-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const emp = employees.find((e) => e.id === id);
                if (emp) onSelect(emp);
            }}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar colaborador..."
                />
            }
        />
    );
};

PortfolioSidebar.propTypes = {
    employees: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default PortfolioSidebar;
